/** `/#section` → home hash, so Concepts nav can reach landing anchors. */
export function homeHashFromLandingTo(to: string): string | null {
  if (!to.startsWith('/#')) return null
  const hash = to.slice(2)
  return hash.length > 0 ? hash : null
}
